import type { ApPayeeDetail as ApPayeeDetailType } from 'ap-openapi';

export const createApPayeeDetail = (
  id: string,
  apPayeeDetail?: ApPayeeDetailType
): ApPayeeDetailType => {
  return {
    code: '',
    name: '',
    priority: 0,
    book_date: apPayeeDetail?.book_date ?? '',
    contact_office_members: [],
    default_cr_item: undefined,
    default_cr_sub_item: undefined,
    default_dept: undefined,
    default_ex_item: undefined,
    default_name: null,
    default_project: undefined,
    display_name: '',
    foreign_currency: undefined,
    id: id,
    invoice_registration_number: '',
    is_tax_included: apPayeeDetail?.is_tax_included,
    is_withholding_tax:
      id === '1006' ? false : apPayeeDetail?.is_withholding_tax ?? false,
    payment_date: apPayeeDetail?.payment_date ?? '',
    payment_method: undefined,
  };
};
